<script setup lang="ts">
import { onMounted } from 'vue';
import { useState } from '@/state';

onMounted(() => {
  useState().setTheme()
});
</script>

<template>
  <router-view/>
</template>

<style>
.bg-main {
    background: var(--bg-main)!important;
}
.bg-comp {
    background: var(--bg-comp)!important;
}
.color-light-black-n-dark-white {
    color: var(--light-black-n-dark-white)!important;
}
.color-light-white-n-dark-black {
    color: var(--light-white-n-dark-black)!important;
}
.c-pointer {
  cursor: pointer;
}
.v-hidden {
  visibility: hidden;
}
</style>
